function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 4.25V0H0.75C0.334375 0 0 0.334375 0 0.75V15.25C0 15.6656 0.334375 16 0.75 16H11.25C11.6656 16 12 15.6656 12 15.25V5H7.75C7.3375 5 7 4.6625 7 4.25ZM9 11.625C9 11.8313 8.83125 12 8.625 12H3.375C3.16875 12 3 11.8313 3 11.625V11.375C3 11.1687 3.16875 11 3.375 11H8.625C8.83125 11 9 11.1687 9 11.375V11.625ZM9 9.625C9 9.83125 8.83125 10 8.625 10H3.375C3.16875 10 3 9.83125 3 9.625V9.375C3 9.16875 3.16875 9 3.375 9H8.625C8.83125 9 9 9.16875 9 9.375V9.625ZM9 7.375V7.625C9 7.83125 8.83125 8 8.625 8H3.375C3.16875 8 3 7.83125 3 7.625V7.375C3 7.16875 3.16875 7 3.375 7H8.625C8.83125 7 9 7.16875 9 7.375ZM12 3.80938V4H8V0H8.19063C8.39062 0 8.58125 0.078125 8.72188 0.21875L11.7812 3.28125C11.9219 3.42188 12 3.6125 12 3.80938Z",
  fill: "#0080CB"
});

var SvgChecklist = function SvgChecklist(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChecklist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checklist.db65cb4c.svg";
export { ForwardRef as ReactComponent };